import { Alert, Box, Stack, Tab, Tabs } from '@mui/material'
import * as React from 'react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import MainContentContainer from '@/components/layouts/MainContentContainer'
import PageHeader from '@/components/layouts/PageHeader'
import TabPanel from '@/components/layouts/TabPanel'
import CountrySelector from '@/features/bidding/components/CountrySelector'
import ExportMfrrCapacityBid from '@/features/bidding/components/export/ExportMfrrCapacityBid'
import ExportMfrrEnergyBid from '@/features/bidding/components/export/ExportMfrrEnergyBid'
import { useBiddingContext } from '@/features/bidding/contexts/BiddingContext'

function ExportMfrrBid() {
  const { t } = useTranslation()
  const { selectedCountry } = useBiddingContext()

  const SUPPORTED_COUNTRIES = ['fi', 'no']

  return (
    <>
      <PageHeader
        appBarContent={
          <Box alignItems="center" display="flex" flexDirection="row">
            <CountrySelector />
          </Box>
        }
        breadcrumbItems={[{ text: t('component.page_header.bidding'), to: '/bidding' }]}
        pageTitle={t('component.page_header.export_mfrr_bid')}
      />
      {SUPPORTED_COUNTRIES.includes(selectedCountry) ? <SupportedCountry /> : <NotSupportedCountry />}
    </>
  )
}

function SupportedCountry() {
  const SUPPORTED_COUNTRIES_FOR_ENERGY_BIDS = ['fi']

  const { t } = useTranslation()
  const { selectedCountry } = useBiddingContext()

  const [activeTab, setActiveTab] = useState(0)

  return (
    <>
      <Box sx={{ mt: 2, borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          scrollButtons="auto"
          style={{ minHeight: 0 }}
          value={activeTab}
          variant="scrollable"
          onChange={(_, newValue) => {
            setActiveTab(newValue)
          }}
        >
          <Tab label={t('bidding.results.capacity_bids')} style={{ minHeight: 0 }} value={0} />
          {SUPPORTED_COUNTRIES_FOR_ENERGY_BIDS.includes(selectedCountry) && (
            <Tab label={t('bidding.results.energy_bids')} style={{ minHeight: 0 }} value={1} />
          )}
        </Tabs>
        {selectedCountry === 'no' && (
          <Alert data-testid="warning" severity="warning">
            {t('bidding.export_mfrr_bid.only_norway_direct_supported')}
          </Alert>
        )}
      </Box>

      <MainContentContainer>
        <TabPanel index={0} value={activeTab}>
          <ExportMfrrCapacityBid />
        </TabPanel>

        {SUPPORTED_COUNTRIES_FOR_ENERGY_BIDS.includes(selectedCountry) && (
          <TabPanel index={1} value={activeTab}>
            <ExportMfrrEnergyBid />
          </TabPanel>
        )}
      </MainContentContainer>
    </>
  )
}

function NotSupportedCountry() {
  const { t } = useTranslation()

  return (
    <Stack mt={3}>
      <Alert data-testid="unsupported" severity="info">
        {t('bidding.export_mfrr_bid.not_supported')}
      </Alert>
    </Stack>
  )
}

export default ExportMfrrBid
